import React, {Fragment, useEffect, useState, useContext} from 'react';
import {Button, Modal, Form, TreeSelect, Select, Input, Radio, notification} from 'antd';
import {useRouteMatch} from 'react-router-dom';
import {AppContext} from '../state';

export function AddSchemaRefFieldDialog({onAddField, forceFieldName, title = 'Add Schema $ref', nameLabel = 'Field Name', types}) {
    const {backend} = useContext(AppContext);
    const [visible, setVisible] = useState();
    const {params} = useRouteMatch('/:env/standards/:category');
    const [form] = Form.useForm();
    const [library, setLibrary] = useState([]);
    const [availableModels, setAvailableModels] = useState([]);

    async function handleOk() {
        try {
            const values = await form.validateFields();
            setVisible(false);
            onAddField && onAddField({name: values.name, $ref: values.model, type: values.type});
        } catch (err) {
            console.error(err);
            notification.error({title: 'Validation Error', description: err.message, placement: 'bottomRight'});
        }
    }

    useEffect(() => {
        async function loadLibrary() {
            const data = await backend.loadLibrary();
            setLibrary(data);
        }
        loadLibrary();
    }, []);

    function handleShow() {
        form.resetFields();
        setVisible(true);
    }

    async function handleTargetSpecChange(val) {
        const [category, key] = val.split('-');
        // merge in local models to grab uncommitted models
        setAvailableModels(await backend.loadModelRefs({category, key, from: params.category, env: params.env, types}));
    }

    async function handleModelSearch(keywords) {
        return availableModels.filter((m) => m.key.indexOf(keywords) !== -1 || m.name.indexOf(keywords) !== -1);
    }

    return (
        <Fragment>
            <Button style={{marginLeft: 5}} className="addRef" size="small" type="secondary" onClick={handleShow}>
                Add $ref
            </Button>
            {visible && (
                <Modal
                    title={title}
                    open={visible}
                    destroyOnHidden
                    footer={[
                        <Button key="cancel" className="addRef" onClick={() => setVisible(false)}>
                            Cancel
                        </Button>,
                        <Button key="submit" className="addField" type="primary" onClick={handleOk}>
                            Add $ref
                        </Button>,
                    ]}
                    onCancel={() => setVisible(false)}>
                    <Form form={form} initialValues={{type: 'object'}}>
                        <Form.Item name="targetSpec" label="Schema Reference" rules={[{required: true, message: 'Please add Schema Reference'}]}>
                            <TreeSelect
                                showSearch
                                treeDefaultExpandAll
                                styles={{popup: {root: {maxHeight: 400, overflow: 'auto'}}}}
                                style={{width: '100%'}}
                                treeData={library}
                                onChange={handleTargetSpecChange}
                                placeholder="Please select a schema from your library"
                            />
                        </Form.Item>
                        <Form.Item name="model" label="Target Model" rules={[{required: true, message: 'Please add Target Model'}]}>
                            <Select showSearch placeholder="Select a model from target specification (above)" onSearch={handleModelSearch} notFoundContent={null}>
                                {availableModels.map((m) => (
                                    <Select.Option key={m.link} value={m.link}>
                                        {m.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Type" name="type">
                            <Radio.Group>
                                <Radio value="object">Object</Radio>
                                <Radio value="array">Array</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {forceFieldName ? (
                            <Form.Item name="name" label={nameLabel} rules={[{required: true, message: 'Name is required'}]}>
                                <Input />
                            </Form.Item>
                        ) : (
                            <Form.Item name="name" label={`${nameLabel} (optional)`}>
                                <Input />
                            </Form.Item>
                        )}
                    </Form>
                </Modal>
            )}
        </Fragment>
    );
}
